import { render, staticRenderFns } from "./ContentBody.vue?vue&type=template&id=d084acc2&"
import script from "./ContentBody.vue?vue&type=script&lang=js&"
export * from "./ContentBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d084acc2')) {
      api.createRecord('d084acc2', component.options)
    } else {
      api.reload('d084acc2', component.options)
    }
    module.hot.accept("./ContentBody.vue?vue&type=template&id=d084acc2&", function () {
      api.rerender('d084acc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/ContentBody.vue"
export default component.exports